import { useState } from "react";
import { ChevronDown, ChevronUp, FileText } from "lucide-react";

export const CallTranscript = ({ call }) => {
  const [expanded, setExpanded] = useState(false);
  const text = call.transcript?.text;
  if (!text) return null;
  const long = text.length > 280 || text.split("\n").length > 3;
  return <div className="mt-3 border-t border-border pt-3 min-w-0" data-testid={`call-transcript-${call.id}`}>
    <div className="flex items-center gap-1.5 text-xs font-semibold text-secondary mb-2"><FileText size={14} /> Call transcript</div>
    {call.transcript.summary && <p className="text-xs text-muted-foreground mb-2 line-clamp-2 break-words" data-testid={`transcript-summary-${call.id}`}>{call.transcript.summary}</p>}
    <div id={`transcript-text-${call.id}`} data-testid={`transcript-text-${call.id}`}
      className={`text-sm whitespace-pre-wrap [overflow-wrap:anywhere] ${expanded ? "max-h-96 overflow-y-auto pr-2" : "line-clamp-3"}`}>{text}</div>
    {long && <button type="button" onClick={() => setExpanded(!expanded)} aria-expanded={expanded} aria-controls={`transcript-text-${call.id}`}
      data-testid={`transcript-toggle-${call.id}`} className="mt-2 inline-flex items-center gap-1 text-sm font-semibold text-secondary hover:underline">
      {expanded ? <ChevronUp size={14} /> : <ChevronDown size={14} />}{expanded ? "View less" : "View more"}
    </button>}
  </div>;
};